module.exports = __webpack_public_path__ + "static/media/pic1.cab5ad98.jpg";